import LoginTopBanner from "../../layout/AuthLayout/authTopbanner";
import { useTranslation } from "react-i18next";

export default function ProtectedLayout({ children }) {
  const { t } = useTranslation();

  return (
    <div className="auth-layout">
      <div id="Auth" className="container-section">
        <LoginTopBanner />
        <div style={{ overflow: "hidden" }}>
          <div className="otp-auth-card">{children}</div>
        </div>
      </div>
    </div>
  );
}
